import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import Link from "next/link"
import MainBanner from '../../../components/MainBanner';
import AllJobSearch from '../../../components/AllJobSearch';
import FeaturedEmployersImageWithText from '../../../components/FeaturedEmployersImageWithText';
import FeaturedEmployersImageWithTextInverted from '../../../components/FeaturedEmployersImageWithTextInverted';
import IconsGrid from '../../../components/IconsGrid';
import ColContent from '../../../components/ColContent';
import TwoColContent from '../../../components/TwoColContent';
import ImageTextContent from '../../../components/ImageTextContent';
import LatestTestimonials from '../../../components/LatestTestimonials';
import TwoColContentBehavior from '../../../components/TwoColContentBehavior';

export default function JobSeekersIndividualPage({
    global,
    page,
    client_cat_value,
    testimonials
}) {
    return (
        <>
            <SeoHead
                page_name={`${page.title} | The global house of tech and transformation recruitment | Lorien`}
                canonical_link={`job-seekers/${page.url_slug}`}
            />
            <MainBanner
                global={global}
                 pathPrefix={`job_seekers.${page.url_slug}featured_employers_page.main_banner`}
                customClass={`featured-employer-page anchor-offset`}
                content={
                    <>
                        {page?.banner_content ?
                            <div className="post-content" dangerouslySetInnerHTML={{ __html: page?.banner_content }} />
                            : ""}
                        {page?.banner_button_new_tab ?
                            <Link href={`${page?.banner_button_link}`}>
                                <a className='primaryBtn no-arrow' target="_blank" rel="noreferrer noopener">
                                    {page?.banner_button_title}
                                </a>
                            </Link> :
                            <>
                                {page?.banner_button_link ?
                                    <Link href={`${page?.banner_button_link}`}>
                                        <a className='primaryBtn no-arrow'>
                                            {page?.banner_button_title}
                                        </a>
                                    </Link> : null}
                            </>
                        }
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`${page?.banner_image ? page.banner_image : "/site-assets/images/main-banner.jpg"}`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
                editableContent={false}
            />
            <FeaturedEmployersImageWithText
                global={global}
                pathPrefix={`job_seekers.featured_employers_page.${page.url_slug}.featured_employers_with_with_text`}
                customClass={`py-5 featured-employer-page ${page.url_slug}-page overflow-hidden`}
                post={page?.image_with_text}
                page={page}
                secondary_post={page?.roles}
                pageButtonLink={`/job-seekers/featured-employers/`}
                pageButtonTitle={`Back to featured employers`}
            />
            <ColContent
                global={global}
                title={
					<h2 className='mb-4'>Santander's purpose</h2>
				}
                text={
                    <>
                        <p className='lead'>At Santander they're driven by their purpose- to help <em>people and businesses prosper.</em></p>
                        <p className='lead'>They help customers in the moments that matter most, so that they can create change for themselves and those around them.</p>
                        <p className='lead'>That's why Santander are continually developing new ways to serve their customers, and are committed to delivering an outstanding experience by living their values of <em>Simple, Personal and Fair.</em></p>
                    </>
                }
                items={null}
            />
            {page.banner_image_2 ?
                <MainBanner
                    global={global}
                    pathPrefix={`job_seekers.featured_employers_page.${page.url_slug}.main_banner_2`}
                    customClass={`featured-employer-page ${page.url_slug}-page invert none-main-banner`}
                    content={
                        <>
                            {page?.banner_image_2_banner_content ?
                                <div className="post-content" dangerouslySetInnerHTML={{ __html: page?.banner_image_2_banner_content }} />
                                : ""}
                            {page?.banner_image_2_banner_button_new_tab ?
                                <Link href={`${page?.banner_image_2_banner_button_link}`}>
                                    <a className='primaryBtn no-arrow' target="_blank" rel="noreferrer noopener">
                                        {page?.banner_image_2_banner_button_title}
                                    </a>
                                </Link> :
                                <>
                                    {page?.banner_image_2_banner_button_link ?
                                        <Link href={`${page?.banner_image_2_banner_button_link}`}>
                                            <a className='primaryBtn no-arrow'>
                                                {page?.banner_image_2_banner_button_title}
                                            </a>
                                        </Link> : null}
                                </>
                            }
                        </>
                    }
                    imageURL1={`/site-assets/images/main-banner.jpg`}
                    imageALT1={`Main Banner`}
                    imageURL2={`${page?.banner_image_2 ? page.banner_image_2 : ""}`}
                    imageALT2={`Overlay Main Banner`}
                    displayImage1={false}
                    editableContent={false}
                />
                : ""}
            <LatestTestimonials
                global={global}
                pathPrefix={`job_seekers.featured_employers_page.${page.url_slug}.latest_testimonials`}
                customClass={`featured-employer-santander py-5`}
                content={
                    <>
                        <h2>Contractor Testimonials</h2>
                    </>
                }
                post={testimonials}
                swiperID={`latestTestimonialsSwiper`}
            />
            <TwoColContentBehavior
                global={global}
                title={<h2>Santander's behaviours and culture</h2>}
                text={
                    <p style={{textAlign: "left"}}>
                        When you join Santander you become a part of an incredible community of people with a shared respect, who put customers at the heart of everything they do. The behaviours below guide Santander on their transformation journey as they innovate to help people and businesses prosper, both in the UK and globally. They are the foundation of how Santander work and connect with each other day-to-day, and something you’ll learn even more about when you join…
                    </p>
                }
                items={[
                    {
                        image: "/site-assets/images/think_customer.png",
                        text: `
                            <h3 style="color:red; font-weight: bold; ">Think Customer</h3>
                            <span style="font-weight: bold;">Santander care about their customers so they go the extra mile to earn their trust and loyalty.</span><br /><br />
                            They put their customers at the heart of everything they do. Santander take individual accountability for creating a customer-centric culture, as being one step ahead of their needs will help to retain their loyalty, create memorable customer experiences and build stronger relationships.
                        `
                    },
                    {
                        image: "/site-assets/images/embrace_change.png",
                        text: `
                        <h3 style="color: red; font-weight: bold;">Embrace Change</h3>
                            <span style="font-weight: bold;">Embrace new challenges and see new ways of doing things as an opportunity to grow.</span><br /><br />
                            Santander truly believe that to create a sustainable and responsible business, and an environment where everyone can thrive, they need to continue to adapt and adopt a growth mindset in a new hybrid environment. They seek out new challenges, embrace new ways of working and continue to focus on wellbeing, ensuring that everyone can truly achieve work life balance and feel fulfilled.
                        `
                    },
                    {
                        image: "/site-assets/images/act_now.png",
                        text: `
                        <h3 style="color: red; font-weight: bold;">Act Now</h3>
                            <span style="font-weight: bold;">Take accountability and manage risks accordingly, always keeping things simple.</span><br /><br />
                            To move at pace as “One Santander”, they look to simplify what they do and how they do it. Always learning from what  they have done and taking all these behaviours – the agility, resilience, strength, and respect for one another – they leverage those traits to make and deliver change for their customers.
                        `
                    },
                    {
                        image: "/site-assets/images/move_together.png",
                        text: `
                        <h3 style="color: red; font-weight: bold;">Move Together</h3>
                            <span style="font-weight: bold;">Seek opportunities to promote collaboration and work together to achieve common goals.</span><br /><br />
                            Success and sustainable growth depend on Santander’s collective efforts and sustained individual commitment. Only by working as a team, as “One Santander”, can they leverage the capabilities of their diverse teams and drive innovation to meet new challenges.
                        `
                    },
                    {
                        image: "/site-assets/images/speak_up.png",
                        text: `
                        <h3 style="color: red; font-weight: bold;">Speak Up</h3>
                            <span style="font-weight: bold;">Feel free to raise any idea, ask any question or escalate any issues or risks, building an environment of respect and trust.  Comfortable sharing and receiving feedback.</span><br /><br />
                            At Santander, they want everyone to feel they can freely express opinions, problems or concerns. They are committed to creating an environment of respect, where everyone has the confidence to be heard. Santander welcome new ideas, as this drives innovation and helps all to better respond to the needs of their customers.
                        `
                    }
                ]}
            />
            {page?.image_with_text_2.map((post, index) => (
                <>
                    {post.image === null ? "" :
                        <FeaturedEmployersImageWithText
                            global={global}
                            pathPrefix={`job_seekers.featured_employers_page.${page.url_slug}.featured_employers_with_with_text_2`}
                            customClass={`py-5 mt-5 featured-employer-page column-reverse`}
                            post={page?.image_with_text_2}
                            secondary_post={page?.roles}
                            pageButtonLink={``}
                            pageButtonTitle={``}
                        />}
                </>
            ))}
            <IconsGrid
                global={global}
                title={
					<h2>#TheSantanderEffect</h2>
				}
                items={[
					{
                        image: '/site-assets/images/santander-icons-active-customers.png',
                        title: '14 million',
                        text: 'active customers'
                    },
                    {
                        image: '/site-assets/images/santander-icons-mortgage-loans.png',
                        title: '£175.2bn',
                        text: 'mortgage stock<br />(2022: £187.1bn)'
                    },
                    {
                        image: '/site-assets/images/santander-icons-uk-corporate-loans.png',
                        title: '48%',
                        text: 'cost-to-income ratio<br />(2022: 47%)'
                    },
                    {
                        image: '/site-assets/images/santander-icons-digital-customers.png',
                        title: '2.20%',
                        text: 'Banking NIM<br />(2022: 2.06%)'
                    },
                    {
                        image: '/site-assets/images/santander-icons-mobil-users.png',
                        title: '7 million',
                        text: 'digital customers'
                    },
                    {
                        image: '/site-assets/images/santander-icons-mortgage-loans-refined-online.png',
                        title: '77%',
                        text: 'digital mortgage retention'
                    },
                    {
                        image: '/site-assets/images/santander-icons-profit.png',
                        title: '£2,149m',
                        text: 'profit before tax<br />(2022: £1,894m)'
                    },
                    {
                        image: '/site-assets/images/santander-icons-padlock.png',
                        title: '15.2%',
                        text: 'CET1 capital ratio<br />(2022: 15.2%)'
                    },
                    {
                        image: '/site-assets/images/santander-icons-pie-chart.png',
                        title: '£794m',
                        text: 'in savings to date from our transformation programme from £1bn investment'
                    },
                    {
                        image: '/site-assets/images/santander-icons-plastic-used.png',
                        title: 'Green Homes Report',
                        text: 'published "Buying into the Green Homes Revolution"'
                    },
                    {
                        image: '/site-assets/images/santander-icons-thumbs-up.png',
                        title: 'Carbon Neutral',
                        text: 'in our own operations'
                    },
                    {
                        image: '/site-assets/images/santander-icons-person.png',
                        title: '1.49%',
                        text: 'stage 3 ratio<br />(2022: 1.24%)'
                    }
				]}
            />
            <TwoColContent
                global={global}
                title={
					<h2>Partnerships and awards</h2>
				}
                text={
                    <p className='lead'>Santander are proud to be recognised as a Top Employer and as one of the UK's Best Workplaces by Great Place To Work, who also commend us as a <strong>Best Workplace for Women</strong> and for <strong>Excellence in Wellbeing</strong>.</p>
                }
                items={[
					{
                        image: "/site-assets/images/santander-partnership-1.png",
                        title: 'Col 1',
                        text: 'Santander receive external recognition for their approach to supporting diversity, featuring in <em>The Times Top 50 for Women</em>, in the Top 30 of the <em>Social Mobility Employer Index</em>, and proudly being awarded the <em>Best for Mental Health and Wellbeing</em> by Working Families. They are also accredited as a <em>Disability Confident Leader</em> and a <em>Carer Confident Employer</em>.'
                    },
                    {
                        image: "/site-assets/images/santander-partnership-2.png",
                        title: 'Col 2',
                        text: 'They promote equality & inclusion through our partnerships including Business in the Community, Stonewall, Business Disability Forum, MyGwork, Working Families, Tommy’s Pregnancy & Baby Loss Charity, Peppy and more.'
                    },
				]}
            />
            <ImageTextContent
                global={global}
                pathPrefix={`job_seekers.featured_employers_page.${page.url_slug}.image-with-text`}
                title={
                    <>
                        <h2>Tackling Climate Change</h2>
                        <p>First steps on Santander's journey to be net zero by 2050</p>
                    </>
				}
                image={`/site-assets/images/santander-climate-change.png`}
                text={
                    <>
                        <h5>Santander's ambition</h5>
                        <p>To achieve net-zero carbon emissions across the group by 2050.</p>
                        <h5>What this means for them</h5>
                        <p>At Santander, they recognise that climate change is one of the biggest challenges facing society. This is why they have embedded climate change into their sustainability strategy with the goal of reducing their carbon emissions and helping other businesses to do so too.</p>
                        <p>Santander acknowledge that the financial services industry has a critical role to play in the transition to a green economy and they will play their part in supporting the UK transition to low carbon and climate-resilient economy.</p>
                        <h5>Santander's Strategy</h5>
                        <p>Santander have integrated the Climate Strategy into their wider sustainability strategy making it one of the key pillars of focus that will help them remain fully committed to the objectives of the Paris Agreement on climate change.</p>
                    </>
                }
            />
            <FeaturedEmployersImageWithTextInverted
                global={global}
                customClass={`py-5 mt-5 featured-employer-page`}
                post={[
					{
                        image: "/site-assets/images/santander-join-talent-community.jpg",
                        content: "<h3>Join our Talent Community</h3><p>Register with our talent community and we'll keep you up to date on any exciting opportunities we think are right for you.</p>",
                        buttontitle: "Click here to send your details",
                        buttonlink: "mailto:SantanderReferral@lorienglobal.com"
                    }
				]}
            />
            <AllJobSearch
                global={global}
                pathPrefix={`job_seekers_page.all_job_search`}
                sectionID={`all-client-jobs`}
                customClass={`py-5 grayGradientBg position-relative client-jobs`}
                newsletter_content={
                    <>
                        <h2>Subscribe to our newsletter</h2>
                        <p>With insight across the whole of Lorien, we'll keep you ahead of the curve on the talent market.</p>
                    </>
                }
                formId={`f2973c34-4388-4cf9-b22e-2a16efc93e2a`}
                successPageUrl={'/jobs/subscription-success/'}
                jobClientFilter={true}
                client_cat_value={client_cat_value}
                uk_jobs={true}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const page = (await Collection('featured_employers'))
        .filter(function (post) {
            return (
                post.url_slug == "santander"
            );
        }).getItems()[0];
    
    const testimonials = (await Collection("candidate_testimonials"))
        .filter(function (post) {
          return post.page?.en === "Santander";
        })
    .getItems();
  
    const client_cat_value = page.id;

    return {
        props: {
            global,
            page,
            client_cat_value,
            testimonials
        }
    };
}
